// src/components/empreendimento/EmpreendimentoEnderecosForm.tsx

interface Props {
  formData: any;
  handleInputChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  // Função para buscar o CEP e preencher os campos de Logradouro, Cidade e Bairro ID
  onCepSearch: (cep: string) => Promise<void>; 
}

const EmpreendimentoEnderecosForm: React.FC<Props> = ({ 
  formData, 
  handleInputChange, 
  errors,
  onCepSearch 
}) => {
  
  const endereco = formData.endereco || {};
  const logradouro = endereco.logradouro || {};

  const handleCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cep = e.target.value.replace(/\D/g, '');
    
    // Atualiza o zipcode diretamente
    handleInputChange('endereco.logradouro.zipcode', cep);
    
    if (cep.length === 8) {
      onCepSearch(cep);
    }
  };

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">2. Endereço</h3>
      </div>
      <div className="border-t border-gray-200">
        <div className="px-4 py-5 grid grid-cols-1 gap-6 sm:grid-cols-4">
          
          {/* CEP (logradouro.zipcode) */}
          <div className="sm:col-span-1">
            <label className="block text-sm font-medium text-gray-700">CEP</label>
            <input
              type="text"
              value={logradouro.zipcode || ''}
              onChange={handleCepChange}
              maxLength={8}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>

          {/* Nome do Logradouro (logradouro.nome) */}
          <div className="sm:col-span-3">
            <label className="block text-sm font-medium text-gray-700">Logradouro / Rua</label>
            <input
              type="text"
              value={logradouro.nome || ''}
              // Permite edição, mas sugere preenchimento via CEP
              onChange={(e) => handleInputChange('endereco.logradouro.nome', e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>

          {/* Número (numero) */}
          <div className="sm:col-span-1">
            <label className="block text-sm font-medium text-gray-700">Número</label>
            <input
              type="number"
              value={endereco.numero || ''}
              onChange={(e) => handleInputChange('endereco.numero', e.target.value ? parseInt(e.target.value) : undefined)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
          
          {/* Complemento (complemento) */}
          <div className="sm:col-span-3">
            <label className="block text-sm font-medium text-gray-700">Complemento</label>
            <input
              type="text"
              value={endereco.complemento || ''}
              onChange={(e) => handleInputChange('endereco.complemento', e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>

          {/* IDs de Cidade e Bairro (Campos ocultos/automáticos) */}
          {/* Estes campos devem ser atualizados pela função onCepSearch e são importantes para o backend */}
          <input type="hidden" value={logradouro.cidade || 0} name="cidade_id" />
          <input type="hidden" value={logradouro.bairro || 0} name="bairro_id" />
          
          {/* Coordenadas (latitude e longitude) */}
          <div className="sm:col-span-4 grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700">Latitude</label>
              <input
                type="text" // Usando text, pois a interface espera string
                value={endereco.latitude || ''}
                onChange={(e) => handleInputChange('endereco.latitude', e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Longitude</label>
              <input
                type="text" // Usando text, pois a interface espera string
                value={endereco.longitude || ''}
                onChange={(e) => handleInputChange('endereco.longitude', e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpreendimentoEnderecosForm;